import './header-video.scss';
import BceHeaderVideo from './header-video.js';

export default BceHeaderVideo;